import { render, staticRenderFns } from "./ScaleItem.vue?vue&type=template&id=fd41b052&scoped=true&"
import script from "./ScaleItem.vue?vue&type=script&lang=js&"
export * from "./ScaleItem.vue?vue&type=script&lang=js&"
import style0 from "./ScaleItem.vue?vue&type=style&index=0&id=fd41b052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd41b052",
  null
  
)

export default component.exports